import { useEffect, useContext } from 'react';
import { RightsContext } from 'providers/RightsContext';
import { useHistory } from 'react-router-dom';

const useForbiddenAccessClamp = () => {
  const { rights } = useContext(RightsContext);
  const history = useHistory();

  const hasAccess = rights?.data?.hasAccess;
  useEffect(() => {
    if (hasAccess === false) {
      history.push('/forbidden');
    }
  }, [hasAccess, history]);
};

export default useForbiddenAccessClamp;
